import i18n from "i18next";
import { type FC } from "react";

export const CreateTablePlaceholderComponent: FC = () => {
    return <>{i18n.t("table.editForm.placeholder")}</>;
};
